export const preventPropogation = (e) => e.stopPropagation(); 